<template>
  <el-dialog
    title="修改通知"
    :visible.sync="dialogVisible"
    width="50%"
    @close="handleClose"
  >
    <el-form ref="form" :model="formData" label-width="100px">
      <el-form-item label="通知名称" prop="title" required>
        <el-input
          v-model="formData.title"
          placeholder="必填，请填写通知名称"
        />
      </el-form-item>
      <el-form-item label="连接地址" prop="pageUrl" required>
        <el-input
          v-model="formData.pageUrl"
          placeholder="必填，请填写连接地址"
        />
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">取 消</el-button>
      <el-button type="primary" @click="editStoreMsg">保 存</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { updateShopMsg } from '@/api/storeMsgApi'
import { getShopId } from '@/api/shop/shopApi'

export default {
  name: 'EditStoreMsg',
  data() {
    return {
      dialogVisible: false,
      formData: {
        msgId: '',
        title: '',
        pageUrl: '',
        shopId: ''
      }
    }
  },
  methods: {
    open(row) {
      this.formData = { ...row }
      this.dialogVisible = true
    },
    handleClose() {
      this.$refs.form.resetFields()
    },
    async editStoreMsg() {
      try {
        await this.$refs.form.validate()
        this.formData.shopId = getShopId()
        
        const res = await updateShopMsg(this.formData)
        if (res.code === 0) {
          this.$message.success('修改成功')
          this.dialogVisible = false
          this.$emit('refresh')
        }
      } catch (error) {
        console.error('修改失败:', error)
      }
    }
  }
}
</script>